import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../../diccionarios/comisionesModulo';
import { VendedoresRelacionadosService } from '../../services/vendedores-relacionados.service';
import { TipoDeVendedorService } from '../../services/tipo-de-vendedor.service';
import { IndicadoresVivosService } from 'src/app/aplicaciones-modulos/indicadores-vivos/services/indicadores-vivos.service';
import { AltaDeVendedoresService } from '../../services/alta-de-vendedores.service';



@Component({
  selector: 'app-vendedores-relacionados',
  templateUrl: './vendedores-relacionados.component.html',
  styleUrls: ['./vendedores-relacionados.component.css']
})
export class VendedoresRelacionadosComponent implements OnInit {

  tituloCard: string = 'Vendedores Relacionados';
  tituloForm: string = 'Lista De Vendedores Relacionados';

  formulario: FormGroup;
  formularioFiltroTipoDeVendedores: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  cmbEstados: any[] = [
    {
      clave: 'ACTIVO',
      valor: 'ACTIVO'
    },
    {
      clave: 'INACTIVO',
      valor: 'INACTIVO'
    },
  ];

  cmbSiNo: any[] = [
    {
      clave: '1',
      valor: 'SI'
    },
    {
      clave: '0',
      valor: 'NO'
    },
  ];

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _serviciosCRUD: VendedoresRelacionadosService,
    private _tiposDeVendedores: TipoDeVendedorService,
    private _altaDeVendedor: AltaDeVendedoresService,

  ) { }

  ngOnInit() {
    this.modulo = comisionesModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;

    this.formulario = this.fb.group({
      idVendedorRelacionado: ['', null],
      fechaRegistro: ['', []],
      usuario: ['', []],
      tipoVendedorId: ['', [Validators.required]],
      vendedorPrincipalCodSap: ['', [Validators.required]],
      vendedorRelacionadoCodSap: ['', [Validators.required]],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      vendedorRelacionadoNombre: ['', []],

      descripcionTipo: ['', []],
      codNombreVendedorPrincipal: ['', []],
      codNombreVendedorRelacionado: ['', []],
      unidadNegocio: ['', []],
    });

    this.formularioFiltroTipoDeVendedores = this.fb.group({
      idTipoVendedor: ['', []],
    });

    this.formularioFiltroTipoDeVendedores.get('idTipoVendedor').valueChanges
      .subscribe((resp) => {
        // if (resp) {
        this._serviciosCRUD.getTodo(resp).subscribe((res: any[]) => {
          console.log("getTodo()", res)
          this.loading = false;
          this.listaVacia = (res.length === 0) ? true : false;
          this.rowData = res;

          // for (let i = 0; i < this.rowData.length; i++) {
          //   this.rowData[i].fechaInicioSplit = this.rowData[i].fechaInicio != null ? this.rowData[i].fechaInicio.split("T")[0] : '';
          //   this.rowData[i].fechaFinSplit = this.rowData[i].fechaFin != null ? this.rowData[i].fechaFin.split("T")[0] : '';
          // }

          console.log("this.rowData", this.rowData)
        }, (err) => {
          this.loading = false;
          this.listaVacia = true;
          this.rowData = [];
        });
        // }
      });

    this.formulario.get('tipoVendedorId').valueChanges
      .subscribe((resp) => {
        if (resp) {
          this.getVendedores(resp)
        }
        this.getFormValidationErrors();
      });

      this.formulario.get('vendedorRelacionadoCodSap').valueChanges
      .subscribe((resp) => {
        if (resp) {
          this.loading = true;
          this._serviciosCRUD.vendedor(resp).subscribe((res: any) => {
            console.log("getTodo()", res)
            this.loading = false;

            this.formulario.get('vendedorRelacionadoNombre').setValue(res.nombreVendedor1);
  
          }, (err) => {
            this.loading = false;
            this.formulario.get('vendedorRelacionadoNombre').setValue('');
          });
        }
      });

    this.cargarGridcomponent();
    this.getTodo();
    this.tiposDeVendedores();

  }



  listTiposDeVendedores;
  listTiposDeVendedores2;
  tiposDeVendedores() {
    this.loading = true;
    this._tiposDeVendedores.getTiposDeVendedores().subscribe((res: any[]) => {
      console.log("tiposDeVendedores()", res)
      this.loading = false;
      this.listTiposDeVendedores = res;
      this.listTiposDeVendedores2 = res;

      this.listTiposDeVendedores.unshift({
        descripcion: 'TODOS',
        idTipo: '',
      });

      this.formularioFiltroTipoDeVendedores.get("idTipoVendedor").setValue('');

    }, (err) => {
      this.loading = false;
      this.listTiposDeVendedores = [];
      this.listTiposDeVendedores2 = [];
    });
  }

  listVendedores;
  getVendedores(tipoDeVendedor) {
    this.loading = true;
    this._altaDeVendedor.getTodoPorTipo(tipoDeVendedor).subscribe((res: any[]) => {
      console.log("getTiposDeVendedores()", res)
      this.loading = false;
      this.listVendedores = res;

      for (let i = 0; i < this.listVendedores.length; i++) {
        this.listVendedores[i].nombreVendedor1 = this.listVendedores[i].codigoSap + " - " + this.listVendedores[i].nombreVendedor1;
      }

      // this.listVendedores.unshift({
      //   nombreVendedor1: 'TODOS',
      //   idVendedor: '',
      // });

    }, (err) => {
      this.loading = false;
      this.listVendedores = [];
    });
  }

  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.columnDefs = [
      {
        headerName: 'ID',
        field: 'idVendedorRelacionado',
        filter: true,
        sortable: true,
        width: 100,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'TIPO DE VENDEDOR',
        field: 'descripcionTipo',
        sortable: true,
        width: 250,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'CODIGO VENDEDOR PRINCIPAL',
        field: 'codNombreVendedorPrincipal',
        sortable: true,
        width: 350,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'CODIGO VENDEDOR RELACIONADO',
        field: 'codNombreVendedorRelacionado',
        sortable: true,
        width: 350,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'UNIDAD DE NEGOCIO',
        field: 'unidadNegocio',
        sortable: true,
        width: 200,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'FECHA INICIO',
        field: 'fechaInicio',
        sortable: true,
        width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: 'FECHA FIN',
        field: 'fechaFin',
        sortable: true,
        width: 160,
        filter: true,
        // cellStyle: this.changeCellColor.bind(this),
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();

  }

  nuevo() {
    this.formulario.reset();
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = (today.getMonth() + 1); // Months start at 0!
    let dd = today.getDate();
    let ddd, mmm;

    if (dd < 10) { ddd = '0' + dd; } else { ddd = dd; }
    if (mm < 10) { mmm = '0' + mm; } else { mmm = mm; }

    const formattedToday = yyyy + '-' + mmm + '-' + ddd;
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.formulario.get('fechaRegistro').setValue(formattedToday);
    this.formulario.get('usuario').setValue(userData.login2);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Vendedor Relacionado';
  }

  editar({ rowData }) {
    console.log("editar", rowData)
    this.formulario.reset();
    rowData.fechaFin = rowData.fechaFin.split("T")[0];
    rowData.fechaInicio = rowData.fechaInicio.split("T")[0];
    rowData.fechaRegistro = rowData.fechaRegistro.split("T")[0];
    rowData.vendedorRelacionadoNombre = '';
    this.formulario.setValue(rowData);
    document.getElementById('buttonAbrirModal').click();
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      this.guardar();
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Vendedores Relacionados';
    this.tituloForm = 'Lista De Vendedores Relacionados';
  }

  /** SERVICIOS */
  getTodo() {
    this.listaVacia = true;
    this.loading = true;

    this._serviciosCRUD.getTodo('').subscribe((res: any[]) => {
      console.log("getTodo()", res)
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {
    console.log("eliminar", rowData)
    this._utils
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this._serviciosCRUD.delete(rowData.idVendedorRelacionado),
      })
      .then((res: any) => {
        this.getTodo();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });

  }

  guardar() {

    let datos = this.formulario.getRawValue();
    datos.fechaFin = datos.fechaFin + "T00:00:00";
    datos.fechaInicio = datos.fechaInicio + "T00:00:00";
    datos.fechaRegistro = datos.fechaRegistro + "T00:00:00";

    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._serviciosCRUD.save(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getTodo();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  actualizar() {
    console.log("actualizar");

    let datos = this.formulario.getRawValue();
    datos.fechaFin = datos.fechaFin + "T00:00:00";
    datos.fechaInicio = datos.fechaInicio + "T00:00:00";
    datos.fechaRegistro = datos.fechaRegistro + "T00:00:00";

    console.log(this.formulario.getRawValue())
    this._utils.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._serviciosCRUD.update(datos),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getTodo();
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      console.log(err);
      // this._utils.mensajeErroToast(err.error.message, 5000);
    });
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }
}
